import React from 'react';
import { Label, Pane, Checkbox, NumericInput } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import Model from "./JSONExportFormatterModel.js";
import S from './ExportFormatterEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.export.JSONExportFormatterEditor');
export default function JSONExportFormatterEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(Pane, {
    className: S.grid,
    children: [/*#__PURE__*/_jsx(Label, {
      children: t('indentationSpace')
    }), /*#__PURE__*/_jsx(NumericInput, {
      eventData: "setSpace",
      value: Model.getSpace(value),
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Checkbox, {
      label: t('newline'),
      eventData: "setNewline",
      value: Model.getNewline(value),
      onChange: onModelChange
    })]
  });
}